import Logo from 'assets/images/logo.svg';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Image } from 'shared/components/Image';
import LiveChatWidgetComponent from 'shared/components/liveChatWidget';
import { State } from '../../../interface';
import { liveChat } from '../../store/layout.action';
import FooterList from '../footer/component/footerList';
import FooterSocial from '../footer/component/footerSocial';
import { FOOTER_HELP, FOOTER_INFORMATION, FOOTER_SHORTCUTS, FOOTER_SOCIAL } from './component/footerNavigation';
import './styles.scss';

const Footer: React.FC = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	useEffect(() => {
		setTimeout(() => {
			const footerHeight =
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				document.getElementsByTagName('footer')[0] && document.getElementsByTagName('footer')[0]!.getBoundingClientRect().height;
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			document.getElementsByTagName('body')[0]!.style.setProperty('--footer-height', `${footerHeight}px`);
		}, 1000);
	}, []);

	const isLiveChatVisible = useSelector<State, any>((state) => state.layout.isLiveChatVisible);

	const handleOnClick = (param: string) => {
		dispatch(liveChat(param));
	};

	const footerCopyright = (
		<div className="footer__copyright">
			<div className="footer__logo">
				<Image src={Logo} description="Logo" textOnImage="BETFAN" />
			</div>
			<div className="footer__copyright__wrapper">
				<div className="footer__copyright__text">{t('footerText')}</div>
				<div className="footer__copyright__text">{t('footerText2')}</div>
				<div className="footer__copyright__text">{t('footerText3')}</div>
				<div className="footer__copyright__text">{t('footerText4')}</div>
			</div>
		</div>
	);

	return (
		<footer className="footer">
			<div className="footer__row">
				<FooterList data={FOOTER_SHORTCUTS} />
				<FooterList data={FOOTER_INFORMATION} />
			</div>
			<div className="footer__row">
				<FooterList data={FOOTER_HELP}>
					<>
						<div onClick={() => handleOnClick('maximized')} className="footerLink">
							{t('chat')}
							<LiveChatWidgetComponent handleChange={handleOnClick} visibility={isLiveChatVisible.isLiveChatVisible} />
						</div>
						{typeof window.Cookiebot?.renew === 'function' && (
							<li className="footerLink">
								<button className="footerLink__link" onClick={() => window.Cookiebot.renew()}>
									{t('cookieSettings')}
								</button>
							</li>
						)}
					</>
				</FooterList>
				<FooterSocial data={FOOTER_SOCIAL} />
			</div>
			{footerCopyright}
		</footer>
	);
};
export default Footer;
